<template>
  <div class="register-wrapper">
    <div class="register-card">
      <h1 class="title">회원가입</h1>
      <p class="subtitle">새로운 계정을 생성하세요</p>
      
      <form @submit.prevent="handleRegister" class="register-form">
        <div class="form-group">
          <label for="userid">아이디</label>
          <div class="input-group">
            <input 
              type="text" 
              id="userid" 
              v-model="userid" 
              placeholder="아이디를 입력하세요"
              required
            >
            <button type="button" @click="checkDuplicate" class="check-btn" :disabled="!userid">중복확인</button>
          </div>
        </div>
        
        <div class="form-group">
          <label for="password">비밀번호</label>
          <input 
            type="password" 
            id="password" 
            v-model="password" 
            placeholder="비밀번호를 입력하세요"
            required
          >
        </div>

        <div class="form-group">
          <label for="confirmPassword">비밀번호 확인</label>
          <input 
            type="password" 
            id="confirmPassword" 
            v-model="confirmPassword" 
            placeholder="비밀번호를 다시 입력하세요"
            required
          >
        </div>

        <button type="submit" class="register-btn" :disabled="isLoading || !isIdChecked">
          <span v-if="!isLoading">회원가입</span>
          <span v-else>처리 중...</span>
        </button>
        
        <div class="links">
          <a @click="$router.push('/')" class="link-btn">로그인으로 돌아가기</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { _baseURL } from '@/config/api';

export default {
  name: 'RegisterPage',
  data() {
    return {
      userid: '',
      password: '',
      confirmPassword: '',
      isLoading: false,
      isIdChecked: false
    }
  },
  watch: {
    userid() {
      this.isIdChecked = false;
    }
  },
  methods: {
    async checkDuplicate() {
      if (!this.userid) return;
      
      try {        
        // API Payload matches UserData class
        const response = await axios.post(`${_baseURL}User/checkaccount`, {
          centeridx: 0,
          authkey: '',  
          userid: this.userid,
          password: '' // Sending empty password for duplication check
        });

        // Assuming response logic based on typical patterns (user need to confirm exact success condition if not provided, assuming ret or generic success)
        // User didn't specify return value for checkaccount, assuming generally positive response means available.
        // Let's assume standard 200 OK means checked. Or look for 'ret' if consistent.
        // Since user didn't specify checkaccount return, I'll assume success means available.
        // UPDATE: Safest to assume similar structure.
        
        if (response.data && response.data.ret === 0) { // Assuming ret=1 means available based on registcenter logic
             this.isIdChecked = true;
             alert('사용 가능한 아이디입니다.');
        } else {
             alert('이미 사용 중인 아이디입니다.');
             this.isIdChecked = false;
        }

      } catch (error) {
        console.error('Check duplicate failed:', error);
        alert('중복 확인 중 오류가 발생했습니다.');
      }
    },
    async handleRegister() {
      if (!this.isIdChecked) {
        alert('아이디 중복 확인을 해주세요.');
        return;
      }
      if (this.password !== this.confirmPassword) {
        alert('비밀번호가 일치하지 않습니다.');
        return;
      }

      this.isLoading = true;
      try {
        const registcenteridx = localStorage.getItem('registcenteridx');
        const authkey = localStorage.getItem('authkey');
        console.log(registcenteridx);
        console.log(authkey);
        const response = await axios.post(`${_baseURL}User/registcenter`, {
          centeridx: registcenteridx,
          authkey: authkey,
          userid: this.userid,
          password: this.password
        });

        if (response.data.ret === 1) {
          alert('회원가입이 완료되었습니다. 로그인해주세요.');
          this.$router.push('/');
        } else {
          alert('회원가입에 실패했습니다.');
        }
      } catch (error) {
        console.error('Registration failed:', error);
        alert('회원가입 중 오류가 발생했습니다.');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.register-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.register-card {
  background: var(--surface-dark);
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.title {
  color: var(--text-light);
  font-size: 2rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.subtitle {
  color: var(--text-muted);
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

.input-group {
  display: flex;
  gap: 0.5rem;
}

.check-btn {
  white-space: nowrap;
  padding: 0 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-light);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.check-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.2);
}

.check-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

label {
  display: block;
  color: var(--text-muted);
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

input {
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: var(--text-light);
  font-size: 1rem;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box; 
}

input:focus {
  border-color: var(--primary-color);
  background: rgba(255, 255, 255, 0.1);
}

.register-btn {
  width: 100%;
  padding: 0.875rem;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 1rem;
}

.register-btn:hover:not(:disabled) {
  opacity: 0.9;
}

.register-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.links {
  margin-top: 1.5rem;
}

.link-btn {
  color: var(--text-muted);
  text-decoration: none;
  font-size: 0.875rem;
  cursor: pointer;
}

.link-btn:hover {
  color: var(--primary-color);
  text-decoration: underline;
}
</style>
